var map = {
	"./camera.svg": 8060,
	"./dashboard.svg": 7743,
	"./locations.svg": 9831,
	"./maintenance.svg": 8814,
	"./pattern.svg": 7633,
	"./rfid.svg": 3142,
	"./satisfaction_survey.svg": 3230,
	"./statistics.svg": 1456
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8801;